import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useNavigate } from "react-router-dom";
import SideNavbar from "../../SideNavbar";

const ExotelLogo = () => (
  <img src="/images/desktop/exotel-logo.svg" alt="Exotel Logo" className="w-30 h-30" />
);

const ExotelIntegration: React.FC = () => {
  const isCollapsed = useAppSelector((state) => state.sidebar.isCollapsed);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-200">
      <div className="fixed top-16 left-0 h-full z-10">
        <SideNavbar />
      </div>
      <div className={`${isCollapsed ? "ml-[70px]" : "ml-[290px]"} mt-[109px] p-8 transition-all duration-300`}>
        <div className="bg-white p-8 rounded-3xl shadow-md">
          <div className="flex items-center gap-4 mb-6">
            <button
              className="text-gray-500 hover:text-gray-900 transition"
              onClick={() => navigate(-1)}
              aria-label="Back"
            >
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-left"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
            </button>
            <ExotelLogo />
            <h1 className="text-2xl font-bold text-gray-900">Exotel Integration</h1>
            
          </div>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded mb-6">
            <p className="text-blue-900 font-medium">
              Ready to supercharge your calling experience? Connect with <span className="font-semibold">Scholarcred</span> to get Exotel Cloud Telephony set up for your organization!
            </p>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Why integrate Exotel with Scholarcred CRM?</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Seamless cloud-based calling directly from your CRM dashboard</li>
              <li>Automatic call recording, logging and tracking for all your leads and clients</li>
              <li>Advanced analytics and call reporting</li>
              <li>Click-to-call for improved productivity</li>
              <li>Enhanced customer engagement and faster response times</li>
              <li>Secure, scalable, and reliable telephony infrastructure</li>
            </ul>
          </div>
          <div className="flex items-center gap-3 bg-gray-100 p-4 rounded-lg mb-6">
            <div>
              <div className="text-gray-900 font-semibold">Get Started with Scholarcred</div>
              <div className="text-gray-600 text-sm">Our team will help you configure Exotel for your business needs and ensure a smooth onboarding process.</div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-3">
            <a
              href="mailto:support@scholarcred.com?subject=Exotel%20Cloud%20Telephony%20Setup"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg shadow transition"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Scholarcred Support
            </a>
            <span className="text-gray-500 text-xs">or call us at <a href="tel:+919497748258" className="underline">+91-94977-48258</a></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExotelIntegration;
